export var REACT_CHANNELIO_INTERNAL_CUSTOMEVENT_TYPE = 'react-channelio-evt';
export var REACT_CHANNELIO_EVENT_METHODS = [
    'onBoot',
    'onShowMessenger',
    'onShow',
    'onHideMessenger',
    'onHide',
    'onBadgeChanged',
    'onChangeBadge',
    'onChatCreated',
    'onCreateChat',
    'onProfileChanged',
    'onChangeProfile',
    'onUrlClicked',
    'onClickRedirect',
];
/**
 * Get `window.CustomEvent`.
 */
export var getCustomEvent = function () {
    if (typeof window.CustomEvent === 'function') {
        return window.CustomEvent;
    }
    // Polyfill `window.CustomEvent`.
    // - ref: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#polyfill
    var CustomEvent = function (typeArg, eventInitDict) {
        var _a, _b, _c;
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(typeArg, (_a = eventInitDict === null || eventInitDict === void 0 ? void 0 : eventInitDict.bubbles) !== null && _a !== void 0 ? _a : false, (_b = eventInitDict === null || eventInitDict === void 0 ? void 0 : eventInitDict.cancelable) !== null && _b !== void 0 ? _b : false, (_c = eventInitDict === null || eventInitDict === void 0 ? void 0 : eventInitDict.detail) !== null && _c !== void 0 ? _c : undefined);
    };
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
    return window.CustomEvent;
};
/**
 * Check whether event method is valid or not.
 */
export function checkEventMethodValidity(method) {
    return REACT_CHANNELIO_EVENT_METHODS.includes(method);
}
/**
 * Create dispatching function for ChannelIO event.
 */
export var createChannelIOEventDispatcher = function (method) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        document.dispatchEvent(new (getCustomEvent())(REACT_CHANNELIO_INTERNAL_CUSTOMEVENT_TYPE, {
            detail: {
                method: method,
                args: args,
            },
        }));
    };
};
